module.exports = __webpack_public_path__ + "static/media/plan_process_one.fc0dc441.svg";